"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageCourseApi = exports.PackageCourseApiFactory = exports.PackageCourseApiFp = exports.PackageCourseApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * PackageCourseApi - axios parameter creator
 * @export
 */
const PackageCourseApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: BuyFreePackageCourse - Difficulty: 2 - Roles can execute: ROLE_CUSTOMER, ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Müşterinin, ücretsiz paketi satın almasını sağlar.
         * @param {BuyFreePackageCommand} [buyFreePackageCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyFreePackageCourse: (buyFreePackageCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course/buy_free_package`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(buyFreePackageCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: GetPackageCourseDetails - Difficulty: 3 - Roles can execute: everybody
         * @summary Paket dersin detaylarını getirir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. Trainings listesinde bulunan CoverPhoto\'ları doldurmak için ise PhotoType.TrainingCover kullanabilirsiniz. Traininglerin içinde bulunan Sets alanı ROLE_CUSTOMER için ders paketi, kullanıcı tarafından satın alınmamış ise gönderilmez. Anonim kullanıcılarda bu kısım her zaman boş dönmelidir. Diğer rollerde ise burası her zaman dolu gelmelidir.
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageCourseDetails: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course/get_package_course_details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ListPackageCourses - Difficulty: 4 - Roles can execute: everybody
         * @summary Paket dersleri listelemeye yarar. PackageCourse entity\'sindeki id alanına göre tersten (DESC) sıralanmalıdır. Sayfa başına 30 adet kayıt dönmelidir. Query PackageCourse içerisindeki name ve description içerisinde aranır. (Bilgi: Postgresql\'de LIKE sorgusu case sensitive çalışmaktadır. Bu sebeple ILIKE (Incasesensitive like) fonksiyonu kullanılabilir). Request içerisinde OnlyPurchasedPackages değeri gelmesi durumunda şayet request\'i gönderen kullanıcının rolü ROLE_CUSTOMER ise UserPackageCourse içerisinde request\'i gönderen hesabın paketi satın alıp almadığı bilgisi sorgulanır. Giriş yapmamış kullanıcılarda IsPurchased değeri her zaman false dönmelidir. Diğer rollerde ise IsPurchased değeri her zaman true dönmelidir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz.
         * @param {number} [lastId]
         * @param {boolean} [onlyPurchasedPackages]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackageCourses: (lastId, onlyPurchasedPackages, query, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course/list_package_courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (lastId !== undefined) {
                localVarQueryParameter['lastId'] = lastId;
            }
            if (onlyPurchasedPackages !== undefined) {
                localVarQueryParameter['onlyPurchasedPackages'] = onlyPurchasedPackages;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: PackageCourseTrainingWatched - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Paket ders bir kullanıcı tarafından izlendiğinde sunucuya bildirilmesi içindir. Kaydedilmeden önce PackageCourseTrainingId\'nin varlığı PackageCourseTraining entitysinden kontrol edilmelidir. Request\'i gönderen hesap ROLE_CUSTOMER ise UserPackageCourse içerisinde PackageCourseTrainingId\'nin bağlı olduğu paketin varlığı kontrol edilmelidir. Şayet izlenme bilgisi daha önceden PackageCourseTrainingWatch içerisine kaydedilmiş ise yeni kayıt açılmamalıdır.
         * @param {PackageCourseTrainingWatchedCommand} [packageCourseTrainingWatchedCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packageCourseTrainingWatched: (packageCourseTrainingWatchedCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course/package_course_training_watched`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(packageCourseTrainingWatchedCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: StartPackageCoursePurchaseProcess - Difficulty: 4 - Roles can execute: ROLE_CUSTOMER, ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Satın alma işleminin başlatılmasını sağlar. Bu kısımda iyzico\'ya satın alınacak ürünlerin bilgileri gönderilir ve iyzico\'dan dönen bilgiler veritabanına henüz tamamlanmamış satın alma olarak kaydedilir. Aynı kişi 2 defa, aynı kursu satın alamaz.
         * @param {Dto} [dto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPackageCoursePurchaseProcess: (dto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/package_course/start_package_course_purchase_process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PackageCourseApiAxiosParamCreator = PackageCourseApiAxiosParamCreator;
/**
 * PackageCourseApi - functional programming interface
 * @export
 */
const PackageCourseApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PackageCourseApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: BuyFreePackageCourse - Difficulty: 2 - Roles can execute: ROLE_CUSTOMER, ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Müşterinin, ücretsiz paketi satın almasını sağlar.
         * @param {BuyFreePackageCommand} [buyFreePackageCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyFreePackageCourse(buyFreePackageCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.buyFreePackageCourse(buyFreePackageCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: GetPackageCourseDetails - Difficulty: 3 - Roles can execute: everybody
         * @summary Paket dersin detaylarını getirir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. Trainings listesinde bulunan CoverPhoto\'ları doldurmak için ise PhotoType.TrainingCover kullanabilirsiniz. Traininglerin içinde bulunan Sets alanı ROLE_CUSTOMER için ders paketi, kullanıcı tarafından satın alınmamış ise gönderilmez. Anonim kullanıcılarda bu kısım her zaman boş dönmelidir. Diğer rollerde ise burası her zaman dolu gelmelidir.
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageCourseDetails(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPackageCourseDetails(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ListPackageCourses - Difficulty: 4 - Roles can execute: everybody
         * @summary Paket dersleri listelemeye yarar. PackageCourse entity\'sindeki id alanına göre tersten (DESC) sıralanmalıdır. Sayfa başına 30 adet kayıt dönmelidir. Query PackageCourse içerisindeki name ve description içerisinde aranır. (Bilgi: Postgresql\'de LIKE sorgusu case sensitive çalışmaktadır. Bu sebeple ILIKE (Incasesensitive like) fonksiyonu kullanılabilir). Request içerisinde OnlyPurchasedPackages değeri gelmesi durumunda şayet request\'i gönderen kullanıcının rolü ROLE_CUSTOMER ise UserPackageCourse içerisinde request\'i gönderen hesabın paketi satın alıp almadığı bilgisi sorgulanır. Giriş yapmamış kullanıcılarda IsPurchased değeri her zaman false dönmelidir. Diğer rollerde ise IsPurchased değeri her zaman true dönmelidir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz.
         * @param {number} [lastId]
         * @param {boolean} [onlyPurchasedPackages]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackageCourses(lastId, onlyPurchasedPackages, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPackageCourses(lastId, onlyPurchasedPackages, query, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: PackageCourseTrainingWatched - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Paket ders bir kullanıcı tarafından izlendiğinde sunucuya bildirilmesi içindir. Kaydedilmeden önce PackageCourseTrainingId\'nin varlığı PackageCourseTraining entitysinden kontrol edilmelidir. Request\'i gönderen hesap ROLE_CUSTOMER ise UserPackageCourse içerisinde PackageCourseTrainingId\'nin bağlı olduğu paketin varlığı kontrol edilmelidir. Şayet izlenme bilgisi daha önceden PackageCourseTrainingWatch içerisine kaydedilmiş ise yeni kayıt açılmamalıdır.
         * @param {PackageCourseTrainingWatchedCommand} [packageCourseTrainingWatchedCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packageCourseTrainingWatched(packageCourseTrainingWatchedCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.packageCourseTrainingWatched(packageCourseTrainingWatchedCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: StartPackageCoursePurchaseProcess - Difficulty: 4 - Roles can execute: ROLE_CUSTOMER, ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Satın alma işleminin başlatılmasını sağlar. Bu kısımda iyzico\'ya satın alınacak ürünlerin bilgileri gönderilir ve iyzico\'dan dönen bilgiler veritabanına henüz tamamlanmamış satın alma olarak kaydedilir. Aynı kişi 2 defa, aynı kursu satın alamaz.
         * @param {Dto} [dto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPackageCoursePurchaseProcess(dto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.startPackageCoursePurchaseProcess(dto, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PackageCourseApiFp = PackageCourseApiFp;
/**
 * PackageCourseApi - factory interface
 * @export
 */
const PackageCourseApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PackageCourseApiFp)(configuration);
    return {
        /**
         * Operation Id: BuyFreePackageCourse - Difficulty: 2 - Roles can execute: ROLE_CUSTOMER, ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Müşterinin, ücretsiz paketi satın almasını sağlar.
         * @param {BuyFreePackageCommand} [buyFreePackageCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buyFreePackageCourse(buyFreePackageCommand, options) {
            return localVarFp.buyFreePackageCourse(buyFreePackageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: GetPackageCourseDetails - Difficulty: 3 - Roles can execute: everybody
         * @summary Paket dersin detaylarını getirir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. Trainings listesinde bulunan CoverPhoto\'ları doldurmak için ise PhotoType.TrainingCover kullanabilirsiniz. Traininglerin içinde bulunan Sets alanı ROLE_CUSTOMER için ders paketi, kullanıcı tarafından satın alınmamış ise gönderilmez. Anonim kullanıcılarda bu kısım her zaman boş dönmelidir. Diğer rollerde ise burası her zaman dolu gelmelidir.
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPackageCourseDetails(id, options) {
            return localVarFp.getPackageCourseDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ListPackageCourses - Difficulty: 4 - Roles can execute: everybody
         * @summary Paket dersleri listelemeye yarar. PackageCourse entity\'sindeki id alanına göre tersten (DESC) sıralanmalıdır. Sayfa başına 30 adet kayıt dönmelidir. Query PackageCourse içerisindeki name ve description içerisinde aranır. (Bilgi: Postgresql\'de LIKE sorgusu case sensitive çalışmaktadır. Bu sebeple ILIKE (Incasesensitive like) fonksiyonu kullanılabilir). Request içerisinde OnlyPurchasedPackages değeri gelmesi durumunda şayet request\'i gönderen kullanıcının rolü ROLE_CUSTOMER ise UserPackageCourse içerisinde request\'i gönderen hesabın paketi satın alıp almadığı bilgisi sorgulanır. Giriş yapmamış kullanıcılarda IsPurchased değeri her zaman false dönmelidir. Diğer rollerde ise IsPurchased değeri her zaman true dönmelidir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz.
         * @param {number} [lastId]
         * @param {boolean} [onlyPurchasedPackages]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPackageCourses(lastId, onlyPurchasedPackages, query, options) {
            return localVarFp.listPackageCourses(lastId, onlyPurchasedPackages, query, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: PackageCourseTrainingWatched - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
         * @summary Paket ders bir kullanıcı tarafından izlendiğinde sunucuya bildirilmesi içindir. Kaydedilmeden önce PackageCourseTrainingId\'nin varlığı PackageCourseTraining entitysinden kontrol edilmelidir. Request\'i gönderen hesap ROLE_CUSTOMER ise UserPackageCourse içerisinde PackageCourseTrainingId\'nin bağlı olduğu paketin varlığı kontrol edilmelidir. Şayet izlenme bilgisi daha önceden PackageCourseTrainingWatch içerisine kaydedilmiş ise yeni kayıt açılmamalıdır.
         * @param {PackageCourseTrainingWatchedCommand} [packageCourseTrainingWatchedCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packageCourseTrainingWatched(packageCourseTrainingWatchedCommand, options) {
            return localVarFp.packageCourseTrainingWatched(packageCourseTrainingWatchedCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: StartPackageCoursePurchaseProcess - Difficulty: 4 - Roles can execute: ROLE_CUSTOMER, ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Satın alma işleminin başlatılmasını sağlar. Bu kısımda iyzico\'ya satın alınacak ürünlerin bilgileri gönderilir ve iyzico\'dan dönen bilgiler veritabanına henüz tamamlanmamış satın alma olarak kaydedilir. Aynı kişi 2 defa, aynı kursu satın alamaz.
         * @param {Dto} [dto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPackageCoursePurchaseProcess(dto, options) {
            return localVarFp.startPackageCoursePurchaseProcess(dto, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PackageCourseApiFactory = PackageCourseApiFactory;
/**
 * PackageCourseApi - object-oriented interface
 * @export
 * @class PackageCourseApi
 * @extends {BaseAPI}
 */
class PackageCourseApi extends base_1.BaseAPI {
    /**
     * Operation Id: BuyFreePackageCourse - Difficulty: 2 - Roles can execute: ROLE_CUSTOMER, ROLE_ADMIN, ROLE_SUPER_ADMIN
     * @summary Müşterinin, ücretsiz paketi satın almasını sağlar.
     * @param {BuyFreePackageCommand} [buyFreePackageCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseApi
     */
    buyFreePackageCourse(buyFreePackageCommand, options) {
        return (0, exports.PackageCourseApiFp)(this.configuration).buyFreePackageCourse(buyFreePackageCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: GetPackageCourseDetails - Difficulty: 3 - Roles can execute: everybody
     * @summary Paket dersin detaylarını getirir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz. Trainings listesinde bulunan CoverPhoto\'ları doldurmak için ise PhotoType.TrainingCover kullanabilirsiniz. Traininglerin içinde bulunan Sets alanı ROLE_CUSTOMER için ders paketi, kullanıcı tarafından satın alınmamış ise gönderilmez. Anonim kullanıcılarda bu kısım her zaman boş dönmelidir. Diğer rollerde ise burası her zaman dolu gelmelidir.
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseApi
     */
    getPackageCourseDetails(id, options) {
        return (0, exports.PackageCourseApiFp)(this.configuration).getPackageCourseDetails(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ListPackageCourses - Difficulty: 4 - Roles can execute: everybody
     * @summary Paket dersleri listelemeye yarar. PackageCourse entity\'sindeki id alanına göre tersten (DESC) sıralanmalıdır. Sayfa başına 30 adet kayıt dönmelidir. Query PackageCourse içerisindeki name ve description içerisinde aranır. (Bilgi: Postgresql\'de LIKE sorgusu case sensitive çalışmaktadır. Bu sebeple ILIKE (Incasesensitive like) fonksiyonu kullanılabilir). Request içerisinde OnlyPurchasedPackages değeri gelmesi durumunda şayet request\'i gönderen kullanıcının rolü ROLE_CUSTOMER ise UserPackageCourse içerisinde request\'i gönderen hesabın paketi satın alıp almadığı bilgisi sorgulanır. Giriş yapmamış kullanıcılarda IsPurchased değeri her zaman false dönmelidir. Diğer rollerde ise IsPurchased değeri her zaman true dönmelidir. CoverPhoto alanını doldurmak için IImageService içerisindeki GetUploadUrls metodunu kullanabilirsiniz. İkinci parametre olarak PhotoType.PackageCourseCover gönderebilirsiniz.
     * @param {number} [lastId]
     * @param {boolean} [onlyPurchasedPackages]
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseApi
     */
    listPackageCourses(lastId, onlyPurchasedPackages, query, options) {
        return (0, exports.PackageCourseApiFp)(this.configuration).listPackageCourses(lastId, onlyPurchasedPackages, query, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: PackageCourseTrainingWatched - Difficulty: 2 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_CUSTOMER, ROLE_PERSONAL_TRAINER
     * @summary Paket ders bir kullanıcı tarafından izlendiğinde sunucuya bildirilmesi içindir. Kaydedilmeden önce PackageCourseTrainingId\'nin varlığı PackageCourseTraining entitysinden kontrol edilmelidir. Request\'i gönderen hesap ROLE_CUSTOMER ise UserPackageCourse içerisinde PackageCourseTrainingId\'nin bağlı olduğu paketin varlığı kontrol edilmelidir. Şayet izlenme bilgisi daha önceden PackageCourseTrainingWatch içerisine kaydedilmiş ise yeni kayıt açılmamalıdır.
     * @param {PackageCourseTrainingWatchedCommand} [packageCourseTrainingWatchedCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseApi
     */
    packageCourseTrainingWatched(packageCourseTrainingWatchedCommand, options) {
        return (0, exports.PackageCourseApiFp)(this.configuration).packageCourseTrainingWatched(packageCourseTrainingWatchedCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: StartPackageCoursePurchaseProcess - Difficulty: 4 - Roles can execute: ROLE_CUSTOMER, ROLE_ADMIN, ROLE_SUPER_ADMIN
     * @summary Satın alma işleminin başlatılmasını sağlar. Bu kısımda iyzico\'ya satın alınacak ürünlerin bilgileri gönderilir ve iyzico\'dan dönen bilgiler veritabanına henüz tamamlanmamış satın alma olarak kaydedilir. Aynı kişi 2 defa, aynı kursu satın alamaz.
     * @param {Dto} [dto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackageCourseApi
     */
    startPackageCoursePurchaseProcess(dto, options) {
        return (0, exports.PackageCourseApiFp)(this.configuration).startPackageCoursePurchaseProcess(dto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PackageCourseApi = PackageCourseApi;
